<ng-container *ngIf="!oAuthService.hasValidAccessToken() || !oAuthService.hasValidIdToken()">
  <!--    router content-->
  <router-outlet class="overflow-auto position-relative" id="router-content"></router-outlet>
</ng-container>

<ng-container *ngIf="oAuthService.hasValidAccessToken() && oAuthService.hasValidIdToken()">
  <app-header class="position-fixed w-100" id="header"></app-header>

  <div class="d-sm-flex wrapper">
    <!--  sidebar-->
    <app-sidebar id="sidebar" class="p-0 position-relative d-flex d-md-block"
      *ngIf="usersService.getUser() && (clientAccountService.getClient() || usersService.isCallCenterUser()) && featuresService.features">
    </app-sidebar>
    <div class="col-md-2"
      *ngIf="usersService.getUser() && (clientAccountService.getClient() || usersService.isCallCenterUser()) && !featuresService.features">
      <app-spinner></app-spinner>
    </div>
    <!--content-->
    <main id="main-content" class="w-100 position-relative">
      <div class="container-fluid pl-3 pt-3 mb-2 bg-white">
        <div *ngIf="pageTitle && !isWarpFlow" id="title-page-bar" class="mb-1">
          <h5 class="font-weight-normal m-0 text">{{ pageTitle | translate }}</h5>
        </div>
        <!--      change unit-->
        <div class="row align-items-center m-0 p-0" *ngIf="clientAccountService.getClient()">
          <h6 class="text-truncate d-block p-0">
            {{clientAccountService.getClient().customerCode}}{{clientAccountService.getClient().businessName ? ' - ' +
            clientAccountService.getClient().businessName : ''}}</h6>
          <h6 class="text-truncate d-block p-0" *ngIf="clientAccountService.getAccount()">
            &nbsp;
            / {{clientAccountService.getAccount().accountCode}}{{clientAccountService.getAccount().description ? ' - ' +
            clientAccountService.getAccount().description : ''}}</h6>
        </div>
        <!--      fine change unit-->
        <app-separator></app-separator>
      </div>
      <!--    router content-->
      <router-outlet class="overflow-auto position-relative" id="router-content"></router-outlet>
    </main>
  </div>
<app-message-viewer></app-message-viewer>
<app-setting-modal></app-setting-modal>
<app-manage-password-modal></app-manage-password-modal>
</ng-container>

<!--<app-change-role-modal></app-change-role-modal>-->